var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame20939(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "url(#paint0_linear_1_49739)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 34.5V12.375H10.0001V27.225H22.8251V15.4999H34.875C36.422 15.4999 37.7463 16.0508 38.8478 17.1525C39.9493 18.254 40.5 19.5781 40.5 21.1249V34.5H37.9999V29.7251H10.0001V34.5H7.5ZM16.2499 25.275C15.0834 25.275 14.1001 24.875 13.3001 24.075C12.5001 23.275 12.1001 22.2916 12.1001 21.1249C12.1001 19.9584 12.5001 18.9751 13.3001 18.1751C14.1001 17.3751 15.0834 16.9751 16.2499 16.9751C17.4166 16.9751 18.4 17.3751 19.2 18.1751C20 18.9751 20.4 19.9584 20.4 21.1249C20.4 22.2916 20 23.275 19.2 24.075C18.4 24.875 17.4166 25.275 16.2499 25.275ZM25.3249 27.225H37.9999V21.1249C37.9999 20.2656 37.6939 19.53 37.0819 18.918C36.4701 18.306 35.7345 18 34.875 18H25.3249V27.225ZM16.2499 22.7749C16.7084 22.7749 17.098 22.6145 17.4188 22.2938C17.7395 21.973 17.8999 21.5834 17.8999 21.1249C17.8999 20.6666 17.7395 20.2771 17.4188 19.9564C17.098 19.6354 16.7084 19.4749 16.2499 19.4749C15.7916 19.4749 15.4021 19.6354 15.0814 19.9564C14.7604 20.2771 14.5999 20.6666 14.5999 21.1249C14.5999 21.5834 14.7604 21.973 15.0814 22.2938C15.4021 22.6145 15.7916 22.7749 16.2499 22.7749Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_49739",
    x1: 0,
    y1: 24,
    x2: 48,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C25C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C18C3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame20939);
export default __webpack_public_path__ + "static/media/Frame 2093 (9).5325bf1ba33db3cb899bf78069378719.svg";
export { ForwardRef as ReactComponent };